export default "__VITE_ASSET__BlGFBLAk__"